<div class="invoice-preview" [class.dialog-mode]="isDialogMode">
  <div class="preview-shell">
    <div class="preview-header">
      <div class="header-copy">
        <!-- <p class="eyebrow">Material Issue</p> -->
        <div class="header-title-row">
          <!-- <h2>Store Print Preview</h2> -->
          <div class="toolbar">
            <mat-slide-toggle color="primary" [(ngModel)]="includeSignature">
              Sign + Stamp
            </mat-slide-toggle>
            <button mat-raised-button color="primary" (click)="printPdf()">
              Print
            </button>
            <button mat-stroked-button color="primary" (click)="downloadPdf()">
              Download PDF
            </button>
            <!-- <button mat-flat-button color="accent" (click)="sendMail()">
              Mail Invoice
            </button> -->
            <button
              *ngIf="isDialogMode"
              mat-icon-button
              type="button"
              class="close-preview-button"
              aria-label="Close preview"
              (click)="closePreview()">
              <mat-icon svgIcon="mat:close"></mat-icon>
            </button>
          </div>
        </div>
        <!-- <p class="subtext">
          ERP-ready issue document with request references at summary and item level.
        </p> -->
      </div>
    </div>

    <div class="preview-frame" *ngIf="previewData; else loading">
      <div class="invoice-page">
        <div *ngIf="previewData.logo" class="page-watermark">
          <img [src]="previewData.logo" alt="Company watermark" />
        </div>

        <div class="invoice-top-strip">
          <span></span>
          <span></span>
        </div>

        <div class="invoice-head">
          <div class="logo-cell">
            <img *ngIf="previewData.logo; else logoFallback" [src]="previewData.logo" alt="Company Logo" />
            <ng-template #logoFallback>
              <div class="logo-fallback">{{ previewData.companyInitials }}</div>
            </ng-template>
          </div>

          <div class="company-cell">
            <div class="document-kicker">Store Department</div>
            <h1>{{ previewData.companyName }}</h1>
            <p *ngIf="previewData.companyAddress">{{ previewData.companyAddress }}</p>
            <p *ngFor="let meta of previewData.companyMeta">{{ meta }}</p>
          </div>

          <div class="invoice-meta-box">
            <div class="meta-badge">MATERIAL ISSUE</div>
            <p><strong>Issue Code:</strong> {{ previewData.issueCode }}</p>
            <p><strong>Issue Date:</strong> {{ previewData.issueDate }}</p>
            <p *ngIf="previewData.issueSlipNo !== '-'"><strong>Slip No:</strong> {{ previewData.issueSlipNo }}</p>
            <p *ngIf="previewData.issueSlipDate !== '-'"><strong>Slip Date:</strong> {{ previewData.issueSlipDate }}</p>
          </div>
        </div>

        <div class="overview-grid">
          <div class="overview-card">
            <span class="overview-label">Issue Type</span>
            <strong>{{ previewData.issueType }}</strong>
          </div>
          <div class="overview-card">
            <span class="overview-label">Warehouse</span>
            <strong>{{ previewData.warehouseName }}</strong>
          </div>
          <div class="overview-card">
            <span class="overview-label">Linked Requests</span>
            <strong>{{ previewData.linkedRequests.length }}</strong>
          </div>
          <div class="overview-card">
            <span class="overview-label">Issue Amount</span>
            <strong>{{ previewData.issueAmount }}</strong>
          </div>
        </div>

        <div class="party-grid single">
          <section>
            <h3>Warehouse / Issue Point</h3>
            <h4>{{ previewData.warehouseName }}</h4>
            <p *ngIf="previewData.warehouseAddress">{{ previewData.warehouseAddress }}</p>
          </section>
          <section *ngIf="previewData.remarks !== '-'">
            <h3>Issue Remarks</h3>
            <p>{{ previewData.remarks }}</p>
          </section>
        </div>

        <div class="trace-section" *ngIf="previewData.linkedRequests.length > 0">
          <h3>Linked Material Requests</h3>
          <div class="trace-card-grid">
            <div class="trace-card" *ngFor="let request of previewData.linkedRequests">
              <strong>{{ request.code }}</strong>
              <span>{{ request.date }}</span>
              <small *ngIf="request.remarks">{{ request.remarks }}</small>
            </div>
          </div>
        </div>

        <table class="items-table">
          <thead>
            <tr>
              <th>SR</th>
              <th>ITEM</th>
              <th>REQ CODE</th>
              <th>REQ DATE</th>
              <th>UOM</th>
              <th>AVAILABLE</th>
              <th>REQ QTY</th>
              <th>PENDING</th>
              <th>ISSUED</th>
              <th>RATE</th>
              <th>AMOUNT</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of previewData.items">
              <td class="center">{{ item.sr }}</td>
              <td>
                <div class="item-title">{{ item.productName }}</div>
                <div class="item-sub" *ngIf="item.remarks">{{ item.remarks }}</div>
              </td>
              <td class="center">{{ item.requestCode || '-' }}</td>
              <td class="center">{{ item.requestDate || '-' }}</td>
              <td class="center">{{ item.uom }}</td>
              <td class="right">{{ item.availableQty }}</td>
              <td class="right">{{ item.requestedQty }}</td>
              <td class="right">{{ item.pendingQty }}</td>
              <td class="right strong">{{ item.issuedQty }}</td>
              <td class="right">{{ item.issueRate }}</td>
              <td class="right strong">{{ item.lineAmount }}</td>
            </tr>
          </tbody>
        </table>

        <div class="bottom-grid">
          <div class="details-block">
            <section>
              <h3>Warehouse / Issue Point</h3>
              <h4>{{ previewData.warehouseName }}</h4>
              <p *ngIf="previewData.warehouseAddress">{{ previewData.warehouseAddress }}</p>
            </section>

            <section *ngIf="previewData.remarks !== '-'">
              <h3>Issue Remarks</h3>
              <p>{{ previewData.remarks }}</p>
            </section>

            <section class="words-block">
              <h3>Amount In Words</h3>
              <p>{{ previewData.issueAmountWords }}</p>
            </section>
          </div>

          <div class="summary-sign-block">
            <div class="summary-card-stack">
              <div class="summary-mini-card">
                <span class="overview-label">Issue Amount</span>
                <strong>{{ previewData.issueAmount }}</strong>
              </div>
              <div class="summary-mini-card">
                <span class="overview-label">Linked Requests</span>
                <strong>{{ previewData.linkedRequests.length }}</strong>
              </div>
            </div>

            <div class="html-sign-area">
              <div class="sign-company">For {{ previewData.companyName }}</div>
              <div class="sign-assets" *ngIf="includeSignature && (previewData.signatureImage || previewData.stampImage)">
                <img
                  *ngIf="previewData.stampImage"
                  class="stamp-img"
                  [src]="previewData.stampImage"
                  alt="Company Stamp" />
                <img
                  *ngIf="previewData.signatureImage"
                  class="signature-img"
                  [src]="previewData.signatureImage"
                  alt="Authorized Signature" />
              </div>
              <div class="sign-name" *ngIf="previewData.signatoryName">
                {{ previewData.signatoryName }}
              </div>
              <div class="sign-role">
                {{ previewData.signatoryTitle || 'Authorized Signatory' }}
              </div>
            </div>
          </div>
        </div>

        <div class="invoice-footer">
          <div class="footer-line">
            <span></span>
            <span></span>
          </div>
          <div class="footer-text">
            <span>Generated using VCS ERP</span>
            <span>Material Issue Document</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loading>
    <div class="loading-state">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p class="loading-text">Generating material issue preview...</p>
    </div>
  </ng-template>
</div>
